export default __webpack_public_path__ + "static/media/exesta.3673afea.svg";